// extracted by mini-css-extract-plugin
export default {"loader":"Loader_Page_loader__Pf-gn","wrapper":"Loader_Page_wrapper__4q67k","logo":"Loader_Page_logo__rFozV","item":"Loader_Page_item__kVfDB"};